import { render, staticRenderFns } from "./ra_list.vue?vue&type=template&id=4b4157a2&scoped=true&"
import script from "./ra_list.vue?vue&type=script&lang=js&"
export * from "./ra_list.vue?vue&type=script&lang=js&"
import style0 from "./ra_list.vue?vue&type=style&index=0&id=4b4157a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4157a2",
  null
  
)

export default component.exports